(function(){
/* 2.9.2026: Englisch braucht die Engine nicht (sie stieg bisher erst NACH dem Laden aller 34 Stuecke aus); ein Buendel statt 34 sequenzieller Requests */
var __asLang=(document.documentElement.lang||"").toLowerCase(); if(!__asLang||__asLang.indexOf("en")===0) return;
var sc=document.currentScript,base=(sc&&sc.src||"").replace(/[?#].*$/,"").replace(/[^\/]*$/,"");
var files=["de-core-c1004.js"],i=0;
function run(){try{var code=decodeURIComponent(escape(atob(window.__asL||"")));var el=document.createElement("script");el.textContent=code;(document.body||document.head||document.documentElement).appendChild(el);}catch(e){if(window.console)console.error("asl",e);}}
function next(){if(i>=files.length){run();return;}var s=document.createElement("script");s.src=base+files[i++]+"?v=c1004";s.onload=next;s.onerror=next;document.head.appendChild(s);}
next();
})();
